/**
 * What a driver rejection, deactivation or removal handed back (#352), as a
 * line for the admin. The backend puts it on `data.removal`. Null when
 * nothing was handed back, so the caller shows nothing.
 */
export function removalSummary(response) {
  const removal = response && response.data && response.data.data && response.data.data.removal;
  if (!removal) return null;
  const parts = [];
  if (removal.releasedOffers) {
    parts.push(`${removal.releasedOffers} pending ride offer(s) released to the traveller`);
  }
  if (removal.unassignedPreBookings && removal.unassignedPreBookings.length) {
    parts.push(`pre-booking(s) ${removal.unassignedPreBookings.join(', ')} handed back to the operator`);
  }
  if (removal.toReassign && removal.toReassign.length) {
    parts.push(`the operator was asked to reassign ${removal.toReassign.join(', ')}`);
  }
  if (removal.handBackFailed && removal.handBackFailed.length) {
    parts.push(`some steps failed and need checking by hand: ${removal.handBackFailed.join(', ')}`);
  }
  return parts.length ? `Done. ${parts.join('; ')}.` : null;
}
